import { render } from "./PolitiquesConfidentialite.vue?vue&type=template&id=3c1b47dc"
import script from "./PolitiquesConfidentialite.vue?vue&type=script&lang=js"
export * from "./PolitiquesConfidentialite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__